import { SVGProps } from "react";

const AlertIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.33594 13.6201C1.13965 13.6201 0.394531 12.7588 0.394531 11.6855C0.394531 11.3574 0.483398 11.0225 0.667969 10.7012L5.95898 1.47266C6.32129 0.830078 6.96387 0.501953 7.62012 0.501953C8.26953 0.501953 8.91211 0.830078 9.28125 1.47266L14.5723 10.7012C14.75 11.0156 14.8457 11.3574 14.8457 11.6855C14.8457 12.7588 14.0938 13.6201 12.9043 13.6201H2.33594ZM7.62695 8.9375C8.00977 8.9375 8.23535 8.71875 8.24902 8.30176L8.35156 4.86328C8.36523 4.44629 8.05078 4.15234 7.62012 4.15234C7.17578 4.15234 6.875 4.44629 6.88867 4.86328L6.98438 8.30859C6.99805 8.71191 7.22363 8.9375 7.62695 8.9375ZM7.62695 11.2891C8.07812 11.2891 8.46094 10.9609 8.46094 10.5098C8.46094 10.0586 8.08496 9.73047 7.62695 9.73047C7.16211 9.73047 6.78613 10.0654 6.78613 10.5098C6.78613 10.9609 7.16895 11.2891 7.62695 11.2891Z"
      fill="#EB3310"
    />
  </svg>
);

export default AlertIcon;
